import React from 'react';

import SoftyCuotaVendedor from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftyCuotaVendedor/List.js';

export default function () {
  return <SoftyCuotaVendedor />;
}
